import React, { useEffect, useCallback, useState } from "react";
import { Spinner } from "reactstrap";

export const SummaryReportCount = ({ userId, month, year, parent, employmentId, parametersId }) => {
    const [load, setLoad] = useState(true);

    const [formData, setFormData] = useState({
        EmploymentId: Number(employmentId),
        UserId: Number(userId),
        ParametersId: Number(parametersId),
        activeStatus: "O",
        employmentId: 0,
        employmentRefId: 0
    });

    // Function to fetch data
    const getData = useCallback(async () => {
        const sendData = {
            UserId: Number(userId),
            MonthId: Number(month),
            EmploymentRefId: parent,
            YearId: Number(year),
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API_LINK}api/Main/Dashdata`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(sendData)
            });

            const data = await response.json();

            if (data !== "No data") {
                setFormData((prevData) => ({
                    ...prevData,
                    activeStatus: data.activeStatus || "O",
                    employmentId: data.employmentId,
                    employmentRefId: data.employmentRefId
                }));
            } else {
                setFormData((prevData) => ({
                    ...prevData,
                    activeStatus: "O",
                    employmentId: 0,
                    employmentRefId: 0
                }));
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle error as needed
        } finally {
            setLoad(false);
        }
    }, [userId, month, year, parent]);

    // Fetch data on mount and when dependencies change
    useEffect(() => {
        if (Number(year) > 0 && Number(month) > 0) {
            setLoad(true);
            getData();
        }
    }, [year, month, userId, parent, getData]);

    return (
        load ? <Spinner color="success" /> :
            formData.activeStatus === "A" ? (
                <>
                    <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>
                    <b style={{ fontSize: 18 }}> D</b>
                </>
            ) : formData.activeStatus === "S" ? (
                <>
                    <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>
                    <b style={{ fontSize: 18 }}> S</b>
                </>
            ) : (
                <>
                    <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>
                    <b style={{ fontSize: 18 }}> N</b>
                </>
            )
    );
};
